import { useEffect, useState } from "react";

const useScreenInfo = () => {
  // Determine initial orientation
  const getOrientation = (): "portrait" | "landscape" =>
    window.matchMedia("(orientation: landscape)").matches
      ? "landscape"
      : "portrait";

  // State for orientation
  const [orientation, setOrientation] = useState<"portrait" | "landscape">(
    getOrientation()
  );

  // Function to update CSS variables
  const updateAppSize = () => {
    document.documentElement.style.setProperty(
      "--app-height",
      `${window.innerHeight}px`
    );
    document.documentElement.style.setProperty(
      "--app-width",
      `${window.innerWidth}px`
    );
  };

  useEffect(() => {
    // Initial update
    updateAppSize();

    const handleResize = () => {
      updateAppSize();

      // Update orientation state if it changes
      const newOrientation = getOrientation();
      if (newOrientation !== orientation) {
        setOrientation(newOrientation);

        // Ensure proper height update after rotation (fix for mobile browsers)
        setTimeout(updateAppSize, 100);
      }
    };

    // Add event listeners
    window.addEventListener("resize", handleResize);
    window.addEventListener("orientationchange", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
      window.removeEventListener("orientationchange", handleResize);
    };
  }, [orientation]);

  return { orientation };
};

export default useScreenInfo;
